import React from 'react';

import {TelehealthBooking as TelehealthBookingDeprecated} from 'presentation/pages/private/booking/pages';

import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {TelehealthBooking} from 'presentation/modules/booking/telehealth/ui/pages/TelehealthBooking';

export const MakeTelehealthBooking = () => {
	const {isEnabled: showTelehealthRefactor} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_REFACTOR_BOOKING_TELEHEALTH,
	);

	if (showTelehealthRefactor) {
		return <TelehealthBooking />;
	}

	return <TelehealthBookingDeprecated />;
};
